import React, { useState, useEffect } from "react";
import {
  Card,
  Col,
  Row,
  Progress,
  Input,
  Space,
  Tooltip,
  Tag,
  Checkbox,
  Button,
  Dropdown,
  Switch,
  Menu,
} from "antd";
import {
  VideoCameraOutlined,
  AudioOutlined,
  LineChartOutlined,
  StarFilled,
  StarOutlined,
  EyeOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeFilled,
  EyeInvisibleFilled,
  LockOutlined,
  MailOutlined,
  KeyOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { extractToken } from "../../../../utils/localStorage";
import { globalRoles } from "../../../../utils/roles";
import { CustomSearchContainer } from "../../../table-item";
import { FiSearch } from "react-icons/fi";
import Filter from "../../../table-item/filter/Filter";
import { StyledTable } from "../../admin/videos/styled";
import moment from "moment";
import TermAndCondition from "../../../record/TermAndCondition";
import PhysicianDetailModal from "../../physician_page/component/PhysicianDetailModal";
import { ccmCoordinatorService } from "../../../../services/user";
import { notify } from "../../../../utils/helper";
import { StyledMenu } from "../../physician_page/styled";
import authService from "../../../../services/auth";

const CCMCoordinatorDashboard = ({
  coordinatorData,
  coordinatorDataCount,
  coordinatorId,
  setIsCoordinatorEdit,
  setCoordinatorId,
  setIsCreateCoordinatorModalOpen,
  loading,
  searchText,
  handleSearch,
  setIsDeleteModalOpen,
  pagination,
  setPagination,
  handleChangeTable,
  isCCMCoordinator,
  isCCMManager,
  fetchCoordinator,
  coordinatorFilterTab,
  setCoordinatorFilterTab,
  specialtyList,
}) => {
  const user = extractToken();

  const [show, setShow] = useState(false);
  const [selectedCoordinatorId, setSelectedCoordinatorId] = useState([]);
  const [isDeatilsOpen, setIsDeatilsOpen] = useState(false);
  const [coordinatorDataById, setCoordinatorDataById] = useState({});
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isMfaEnabled, setIsMfaEnabled] = useState(false);

  const handleCoordinatorCheckbox = (checked, record) => {
    if (checked) {
      setSelectedCoordinatorId([...selectedCoordinatorId, record.id]);
      setIsDropdownVisible(true);
    } else {
      const newSelection = selectedCoordinatorId.filter((id) => id !== record.id);
      setSelectedCoordinatorId(newSelection);
      setIsDropdownVisible(newSelection.length > 0);
    }
  };

  const get2FATag = (is2FaDisable) => {
    if (is2FaDisable) {
      return <Tag color="red">Disabled</Tag>;
    }
    return <Tag color="green">Enabled</Tag>;
  };

  const CCMCoordinatorColumns = [
    {
      title: "Select",
      key: "select",
      width: 60,
      fixed: "left",
      render: (_, record) => (
        <Checkbox
          checked={selectedCoordinatorId.includes(record.id)}
          onChange={(e) => handleCoordinatorCheckbox(e.target.checked, record)}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "fullName",
      width: 250,
      sorter: (a, b) => (a.fullName || "").localeCompare(b.fullName || ""),
    },
    {
      title: "Specialty",
      dataIndex: "specialty",
      key: "specialty",
      align: "center",
      sorter: (a, b) => (a.specialty || "").localeCompare(b.specialty || ""),
      render: (_, record) => record.specialtyName,
    },
    // {
    //   title: "Consent Form",
    //   dataIndex: "consentAccept",
    //   align: "center",
    //   key: "consentAccept",
    //   width: 100,
    //   render: (_, consentAccept) => (
    //     <Tooltip
    //       title={consentAccept?.consentAccept ? "Accepted" : "Not Accepted"}
    //     >
    //       {consentAccept?.consentAccept ? (
    //         <EyeFilled
    //           className="cursor"
    //           style={{ color: "#8a3ef4" }}
    //           onClick={() => {
    //             setConsentData(consentAccept);
    //             setConsentModalOpen(true);
    //           }}
    //         />
    //       ) : (
    //         <EyeInvisibleFilled
    //           className="cursor"
    //           style={{ color: "#a9a9a9" }}
    //         />
    //       )}
    //     </Tooltip>
    //   ),
    //   hidden: user?.role !== "SuperAdmin",
    // },
    {
      title: "2FA Status",
      dataIndex: "is2FaDisable",
      key: "towfaStatus",
      width: 120,
      align: "center",
      sorter: (a, b) => (a.towfaStatus || "").localeCompare(b.towfaStatus || ""),
      render: (is2FaDisable) => get2FATag(is2FaDisable),
    },
    {
      title: "Email Verified",
      dataIndex: "isEmailVerified",
      align: "center",
      key: "isEmailVerifiedText",
      sorter: (a, b) =>
        (a.isEmailVerifiedText || "").localeCompare(
          b.isEmailVerifiedText || ""
        ),
      render: (verified) => (
        <Tag color={verified ? "green" : "orange"}>
          {verified ? "Verified" : "Not Verified"}
        </Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      width: 200,
      key: "createdAt",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
    },
    {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="View Details">
            <div
              onClick={() => {
                setCoordinatorId(record?.id);
                setIsDeatilsOpen(true);
              }}
              className="icon-button-view"
            >
              <EyeOutlined />
            </div>
          </Tooltip>
          {user?.role === globalRoles.SUPERADMIN && (
            <>
              <Tooltip title="Edit">
                <div
                  onClick={() => {
                    setIsCoordinatorEdit(true);
                    setCoordinatorId(record?.id);
                    setIsCreateCoordinatorModalOpen(true);
                  }}
                  className="icon-button-edit"
                >
                  <EditOutlined />
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={() => {
                    setCoordinatorId(record?.id);
                    setIsDeleteModalOpen(true);
                  }}
                  className="icon-button-delete"
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </>
          )}
        </Space>
      ),
    },
  ];

  const getCoordinatorById = async () => {
    try {
      const res = await ccmCoordinatorService.getById(coordinatorId);
      setCoordinatorDataById(res?.data);
      setCoordinatorId("");
    } catch (err) {
      notify("error", err?.data);
    }
  };
  useEffect(() => {
    if (coordinatorId && isDeatilsOpen) {
    getCoordinatorById();
    }
  }, [coordinatorId]);

  const handleAction = async (actionType) => {
    const selectedIds =
      selectedCoordinatorId.length > 0
        && selectedCoordinatorId ;
    if (selectedIds.length === 0) return;
  
     try {
      switch (actionType) {
        case "toggleMfa":
          await authService.disableMfaUser({
            userIds: selectedIds,
            is2FaDisable: !isMfaEnabled,
          });
          notify(
            "success",
            isMfaEnabled
              ? "2FA enabled successfully"
              : "2FA disabled successfully"
          );
          if (selectedCoordinatorId.length > 0) {
            fetchCoordinator();
          }
          break;
        case "resendInvite":
          await authService.resendInviteEmail({ userIds: selectedIds });
          notify("success", "Invite emails sent successfully");
          break;
        case "resetPassword":
          await authService.resetPasswordUsers({ userIds: selectedIds });
          notify("success", "Password reset emails sent successfully");
          break;
      }
      setSelectedCoordinatorId([]);
    } catch (error) {
      notify("error", "Failed to perform action");
    }
  };

  const actionMenu = (
    <StyledMenu>
      <Menu.Item key="mfa">
        <div className="menu-item-content">
          <LockOutlined className="menu-item-icon" />
          <span className="menu-item-text">2FA Disable</span>
          <Switch
            size="small"
            checked={isMfaEnabled}
            onChange={(checked) => {
              setIsMfaEnabled(checked);
              handleAction("toggleMfa");
            }}
          />
        </div>
      </Menu.Item>
      <Menu.Item
        key="resendInvite"
        onClick={() => handleAction("resendInvite")}
      >
        <div className="menu-item-content">
          <MailOutlined className="menu-item-icon" />
          <span className="menu-item-text">Resend Invite</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="resetPassword"
        onClick={() => handleAction("resetPassword")}
      >
        <div className="menu-item-content">
          <KeyOutlined className="menu-item-icon" />
          <span className="menu-item-text">Reset Password</span>
        </div>
      </Menu.Item>
    </StyledMenu>
  );

  const handlePaginationChange = (page) => {
    setPagination((prev) => ({ ...prev, current: page }));
  };

  const hasData = coordinatorData.length > 0;
  const scroll = hasData.length ? { y: `calc(100vh - 320px)`, x: true } : null;

  return (
    <>
     {isDeatilsOpen && (
      <PhysicianDetailModal 
        isOpen={isDeatilsOpen}
        setOpen={setIsDeatilsOpen}
        DataById={coordinatorDataById}
        title={"Coordinator Details"}
        subtitle={"View the details of the coordinator."}
      />
     )}
    <Row
      className="d-flex w-100"
      style={{ gap: "20px", justifyContent: "space-evenly" }}
    >

      {!isCCMCoordinator && !isCCMManager && (
        <>
          <Col
            span={24}
            className="d-flex"
            style={{ justifyContent: "space-between" }}
          >
            <div
              className="d-flex  gap-12"
              style={{ width: "100%", justifyContent: "start" }}
            >
              <CustomSearchContainer>
                <FiSearch
                  style={{ position: "absolute", zIndex: 1 }}
                  className="icon ml-5"
                />
                <Input
                  placeholder="Search here..."
                  // value={searchText}
                  onChange={(e) => {
                    handleSearch(e.target.value);
                  }}
                />
              </CustomSearchContainer>
              {/* <Filter
                show={show}
                setShow={setShow}
                data={[
                  {
                    title: "Specialty",
                    list: specialtyList,
                    filterList: coordinatorFilterTab,
                    setFilterList: setCoordinatorFilterTab,
                  },
                ]}
              /> */}
            </div>
            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
              }}
            >
              {(selectedCoordinatorId.length > 0) && (
                <Dropdown
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  overlay={actionMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                  open={isDropdownVisible}
                  onOpenChange={setIsDropdownVisible}
                >
                  <Button
                    className="text-primary"
                    icon={<MoreOutlined className="text-primary" />}
                  >
                    Actions (
                    {selectedCoordinatorId.length}
                    )
                  </Button>
                </Dropdown>
              )}
            </div>
          </Col>
          <Col span={24} style={{ flex: 1, padding: "0px" }}>
            <StyledTable
              loading={loading}
              columns={CCMCoordinatorColumns}
              dataSource={coordinatorData}
              rowKey="id"
              scroll={scroll}
              pagination={{
                current: pagination?.current,
                pageSize: pagination?.pageSize,
                showSizeChanger: true,
                pageSizeOptions: [25, 50, 100],
                onShowSizeChange: (current, size) => {
                  setPagination({
                    ...pagination,
                    current,
                    pageSize: size,
                  });
                },
                total: coordinatorDataCount,
                showTotal: (total, range) =>
                  `${range[0]} - ${range[1]} of ${total} coordinators`,
                showQuickJumper: false,
                showLessItems: true,
                onChange: handlePaginationChange,
                itemRender: (page, type, originalElement) => {
                  if (type === "prev") {
                    return (
                      <Button
                        type="text"
                        disabled={pagination?.current === 1}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (pagination.current > 1) {
                            setPagination((prev) => ({
                              ...prev,
                              current: prev.current - 1,
                            }));
                          }
                        }}
                      >
                        Previous
                      </Button>
                    );
                  }
                  if (type === "next") {
                    const maxPage = Math.ceil(coordinatorDataCount / pagination.pageSize);
                    return (
                      <Button
                        type="text"
                        disabled={pagination.current === maxPage}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (pagination.current < maxPage) {
                            setPagination((prev) => ({
                              ...prev,
                              current: prev.current + 1,
                            }));
                          }
                        }}
                      >
                        Next
                      </Button>
                    );
                  }
                  return originalElement;
                },
              }}
              onChange={handleChangeTable}
            />
          </Col>
        </>
      )}

 
    </Row>
    </>
  );
};

export default CCMCoordinatorDashboard;
